import { useEventHotelRoomBlocksQuery } from '@graphql/generated';
import { useShortlistReleasedPayload } from './useShortlistReleasedPayload';
import { isBefore } from 'date-fns';

export const useEventHotelRoomBlocksSubmitted = (eventId: string) => {
  const { loading: roomBlockLoading, data, error } = useEventHotelRoomBlocksQuery({ variables: { eventId }, batchMode: 'fast' });
  const { shortlistIsReleasedPayload, loading: shortlistReleasedLoading } = useShortlistReleasedPayload();
  const submittedDateTime = data?.event?.hotelRoomBlocks?.submittedDateTime;
  const loading = roomBlockLoading || shortlistReleasedLoading;

  let isLeadSubmittedBeforeShortlistRelease: boolean | undefined;
  if (!loading) {
    isLeadSubmittedBeforeShortlistRelease = submittedDateTime && isBefore(new Date(submittedDateTime), new Date(shortlistIsReleasedPayload.dateTime));
  }

  return {
    loading,
    eventInfo: data?.event,
    leadSubmitted: !!submittedDateTime || false,
    shortListSubmitted: !!data?.event?.hotelRoomBlocks?.eventDisplayName || false,
    isLeadSubmittedBeforeShortlistRelease,
    leadStateV2: data?.event?.hotelRoomBlocks?.leadStateV2,
    leadStateV2UpdatedAt: data?.event?.hotelRoomBlocks?.leadStateV2UpdatedAt,
    error
  };
};
